// extracted by mini-css-extract-plugin
export default {"redirectingCasdoor":"login_redirectingCasdoor__4FeK2"};